import PriceFormInput from "./PriceFormInput";
export default PriceFormInput;
